import { Button } from "@mui/material"
import { openDialog } from "lib/@hooks/useDialog"
import { createDataExportRequestEmail } from "lib/data-export-request-dialog/controller/create-data-export-request-email"
import { DataExportRequestDialog } from "lib/data-export-request-dialog/data-export-request-dialog"
import { prevent } from "lib/prevent"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { useCurrentUser } from "lib/store/use-current-user"
import Iconify from "minimals-template/components/Iconify"

export function DownloadBookletRequest() {
    const user = useCurrentUser()

    return (
        <Button
            fullWidth
            size="small"
            onClick={prevent(handleBookletRequest)}
            startIcon={<Iconify icon="ic:round-download" />}
            data-cy="download-pdf-booklet-request-button"
        >
            Request PDF
        </Button>
    )

    async function handleBookletRequest() {
        const request = await openDialog(<DataExportRequestDialog user={user} type="PDF Booklet" typeDisabled={true} />)
        if (request) {
            const result = await createDataExportRequestEmail(request)
            if (result) {
                successSnackbar("Request sent")
            } else {
                errorSnackbar("Request failed")
            }
        }
    }
}
